import { PKG_ID, PACKAGE_V2_REVISIONS, ROLLOUT_PLAN, ROLLOUT_CHAIN } from "./data";
import { StatusChip, Kicker, ChainRow } from "./ui";

export const ActRollout = () => (
    <section data-testid="act-rollout">
        <Kicker>Act 3 — Clarification and controlled rollout plan</Kicker>
        <h2 className="mt-2 text-2xl font-medium tracking-tight text-slate-900">
            Bounded impact receipts reshape the release into a controlled rollout
        </h2>

        <div className="mt-6 grid gap-4 lg:grid-cols-2">
            <div className="rounded-sm border border-slate-200 bg-white p-6" data-testid="package-v2-card">
                <div className="flex flex-wrap items-center justify-between gap-2">
                    <p className="font-mono text-sm font-medium text-blue-950">
                        CHANGE PACKAGE {PKG_ID} VERSION 2
                    </p>
                    <StatusChip tone="blue">Manufacturer revision</StatusChip>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">
                    The manufacturer and technology partner receive bounded impact
                    receipts. The manufacturer revises its own package — no other
                    organisation rewrites it.
                </p>
                <ul className="mt-3 space-y-1 text-sm text-slate-700">
                    {PACKAGE_V2_REVISIONS.map((r) => <li key={r}>· {r}</li>)}
                </ul>
            </div>

            <div className="rounded-sm border border-slate-200 bg-white p-6" data-testid="rollout-plan-card">
                <div className="flex flex-wrap items-center justify-between gap-2">
                    <p className="text-sm font-medium text-slate-900">Bounded deployment plan</p>
                    <StatusChip tone="green">Healthcare Technology Partner</StatusChip>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">
                    The technology partner publishes a staged plan built from its
                    installed-base knowledge — evidence it alone holds.
                </p>
                <ul className="mt-3 space-y-1 text-sm text-slate-700">
                    {ROLLOUT_PLAN.map((r) => <li key={r}>· {r}</li>)}
                </ul>
            </div>
        </div>

        <div className="mt-6 rounded-sm border border-slate-200 bg-white p-6" data-testid="rollout-chain-card">
            <p className="text-xs font-medium uppercase tracking-wide text-slate-400">State chain</p>
            <div className="mt-3">
                <ChainRow steps={ROLLOUT_CHAIN} activeIndex={ROLLOUT_CHAIN.length - 1} testIdPrefix="rollout-chain" />
            </div>
        </div>

        <div className="mt-6 rounded-sm border-l-2 border-blue-950 bg-white p-6" data-testid="rollout-distinction">
            <p className="font-mono text-xs uppercase tracking-[0.14em] text-slate-400">Important distinction</p>
            <p className="mt-2 text-sm font-medium leading-relaxed text-slate-900">
                The network is not voting on whether the manufacturer may issue its
                release. Each role confirms whether it can perform its own part of the
                bounded deployment.
            </p>
        </div>
    </section>
);
